<template>
<!-- クライアント登録画面 -->
<CCard>
  <CCardHeader>
    <a name="/users/register"></a>
    <h2>取引先登録</h2>
  </CCardHeader>
  <CCardBody>
    <p><span class="preika-required-note"><span class="preika-required-note__mark" aria-hidden="true">*</span><span>が付いている項目は必須入力項目です</span></span></p>
    <ValidationObserver ref="obs">
      <CRow v-if="message.length">
        <ul>
          <li class="preika-form-message" v-for="error in message" :key="error">{{ error }}</li>
        </ul>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='取引先企業名' rules="required|max:100" v-slot="ProviderProps">
            <label>取引先企業名<span class="asterisk">*</span></label>
            <CInput v-model="company_name"/>
            <p class="error">
              <span class="error">{{ ProviderProps.errors[0] }}</span>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='取引先担当者名' rules="max:60" v-slot="ProviderProps">
            <CInput label="取引先担当者名" v-model="staff_name" />
            <p class="error">
              <span class="error">{{ ProviderProps.errors[0] }}</span>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='電話番号' rules="tel" v-slot="ProviderProps">
            <CInput label="電話番号" v-model="telephone" description="ハイフンなしで入力してください" />
            <p class="error">
              <span class="error">{{ ProviderProps.errors[0] }}</span>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="6">
          <ValidationProvider name='住所' rules="max:60" v-slot="ProviderProps">
            <CInput label="住所" v-model="address" />
            <p class="error">
              <span class="error">{{ ProviderProps.errors[0] }}</span>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='E-Mail' rules="email" v-slot="ProviderProps">
            <CInput label="E-Mail" v-model="email" placeholder="email@example.com"/>
            <p class="error">
              <span class="error">{{ ProviderProps.errors[0] }}</span>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='支払いサイト' rules="numeric|max:3" v-slot="ProviderProps">
            <CInput label="支払いサイト" v-model="usance" description="支払い期日までの日数を入力してください" />
            <p class="error">
              <span class="error">{{ ProviderProps.errors[0] }}</span>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="6">
          <ValidationProvider name='備考' rules="max:254" v-slot="ProviderProps">
            <CInput label="備考" v-model="remarks"/>
            <p class="error">
              <span class="error">{{ ProviderProps.errors[0] }}</span>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <br>
      <CRow class="mt-3 align-items-center">
        <!-- 左寄せ：戻る -->
        <CCol class="text-start">
          <button class="btn btn-secondary btn-sm" @click="valueCheck">戻る</button>
        </CCol>
        <!-- 横並び：確認 -->
        <CCol class="text-center">
          <button v-on:click="whenValid('obs', openModal)" class="btn btn-info">確認</button>
          <!-- 登録確認モーダルコンポーネント呼出 -->
          <ClientRegisterModal 
            :draggable="true" 
            :resizable="true" 
            :name="company_name" 
            :staff_name="staff_name" 
            :tel="telephone" 
            :address="address" 
            :mail="email" 
            :usance="usance" 
            :remarks="remarks" 
            :authorized="authorized" 
            :loading="loading"
            v-show="showModal" 
            @register="register" 
            @close="closeModal"
          >
          </ClientRegisterModal>
        </CCol>
        <!-- 空白スペース用 -->
        <CCol ></CCol>
      </CRow>
    </ValidationObserver>
  </CCardBody>
</CCard>
</template>

<script>
import submitWhenValidMixin from '@/mixins/submitWhenValidMixin'
import ConstList from './../ConstList'
import { requestFailureMessage } from '@/utils/requestFailure'
import ClientRegisterModal from './ClientRegisterModal'
import axios from 'axios'
export default {
  mixins: [submitWhenValidMixin],
  name: 'ClientRegister',
  components: {
    ClientRegisterModal
  },
  data() {
    return {
      showModal: false,
      company_name: '',
      staff_name:'',
      telephone: '',
      address: '',
      email: '',
      usance:'',
      remarks:'',
      message: [],
      authorized: false,
      clientList:'',
      loading: false,
    }
  },

  created() {
        this.clientList = ConstList.ROUTE_CLIENT_LIST;
      },

  methods: {
    // クライアント管理へ遷移する際の入力値チェック
    valueCheck: function () {
      if ((this.company_name) || (this.staff_name) || (this.telephone) || (this.address) || (this.email) || (this.usance) || (this.remarks)){
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({ 
            name: this.clientList
          });
          }
        } else {
          this.$router.push({ 
            name: this.clientList
         });
       }
    },
    // モーダルを表示
    openModal: function () {
      this.showModal = true
    },
    // 登録内容を送信
    register: function () {
      this.loading = true;
      const jsonList = {
      company_name: this.company_name,
      staff_name: this.staff_name,
      telephone: this.telephone,
      address: this.address,
      email: this.email,
      usance: this.usance,
      remarks: this.remarks,
      }
      axios
        .post((process.env.VUE_APP_API_ORIGIN) + '/client/register', jsonList, {
          headers: {'content-type': 'application/json'}
          })
        .then(response => {
          if (response.data === ConstList.SUCCESS) {
            this.authorized = true
            alert(ConstList.REGISTER_MESSAGE)
            this.$router.push({ 
              name: ConstList.ROUTE_CLIENT_LIST
              });
          } else {
            this.message[0] = response.data
            this.showModal = false
          }
        })
        .catch(error => {
          axios
          .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
          .then(() => {
            alert(requestFailureMessage(error));
          })
          .catch(() => {
            alert(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
          })
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false
    }
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
.asterisk {
  color: red;
}
</style>
